<template>
  <a-col :span="24">
    <a-form-item label="树形数据">
      <a-textarea
        v-model:value="text"
        :rows="6"
        placeholder='[{"value":"1","label":"父级1","children":[{"value":"1-1","label":"子级1-1"}]}]'
      />
      <div
        v-if="error"
        class="json-error"
      >
        {{ error }}
      </div>
    </a-form-item>
  </a-col>
</template>

<script setup lang="ts">
/* 树形本地数据配置（共享，treeselect/cascader 专属）：JSON 文本编辑 + 实时校验写回 config.options。
   外壳类型切换会整体替换 config 对象（treeselect↔cascader 共用本组件不重挂载），
   因此 watch config 引用变化时重新从 config.options 初始化（对齐原版 syncTreeDataText 行为）。 */
import { ref, watch } from 'vue';

const props = defineProps<{ config: any }>();

const text = ref('');
const error = ref('');

const initFromConfig = () => {
  error.value = '';
  const opts = props.config?.options;
  text.value = Array.isArray(opts) ? JSON.stringify(opts, null, 2) : '';
};

watch(() => props.config, initFromConfig, { immediate: true });

watch(text, (txt) => {
  if (!txt || !txt.trim()) {
    error.value = '';
    props.config.options = [];
    return;
  }
  try {
    const parsed = JSON.parse(txt);
    if (!Array.isArray(parsed)) throw new Error('必须是数组');
    error.value = '';
    props.config.options = parsed;
  } catch (e: any) {
    error.value = 'JSON 无效：' + (e?.message || '解析失败');
  }
});
</script>

<style scoped lang="less">
.json-error {
  color: #f5222d;
  font-size: 12px;
}
</style>
